import { ApiReturn, Product, ProductPayload } from "../../types";
import API from "../index";
import {
  FETCH_PRODUCT_BASE,
  ADD_TO_PRODUCT_BASE,
  EDIT_PRODUCT,
  GET_PRODUCT_BY_SKU,
  IMPORT_PRODUCT_BASE,
} from "./product.endpoint";

export const fetchProductBase = (
  partnerId?: string
): Promise<ApiReturn<Product[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      FETCH_PRODUCT_BASE.replace(":partnerId", partnerId!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const addToProductBase = (
  partnerId: string,
  data: ProductPayload
): Promise<ApiReturn<Product> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.post(
      ADD_TO_PRODUCT_BASE.replace(":partnerId", partnerId),
      data,
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export const getProductBySku = (
  partnerId: string,
  sku: string
): Promise<ApiReturn<Product> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      GET_PRODUCT_BY_SKU.replace(":partnerId", partnerId).replace(":sku", sku),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const editProduct = (
  sku: string,
  partnerId: string,
  product: ProductPayload
): Promise<ApiReturn<Product> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.post(
      EDIT_PRODUCT.replace(":partnerId", partnerId).replace(":sku", sku),
      product,
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const importProductBase = (
  partnerId: string,
  products: any[]
): Promise<ApiReturn<any> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.post(
      IMPORT_PRODUCT_BASE.replace(":partnerId", partnerId),
      { products },
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};